import { lazy, Suspense } from 'react';
import { useParams } from 'react-router-dom';
import LazyLoading from '../../components/LazyLoading';

const LazyAdminOrderEdit = lazy(
  () => import(/* webpackChunkName: 'AdminOrderEdit' */ './index'),
);

export default function AdminOrderEdit() {
  const { orderId } = useParams<{ orderId?: string }>();

  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyAdminOrderEdit orderId={orderId} />
    </Suspense>
  );
}
